/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as activityActions from '../../actions/activityActions';
import Loading from '../common/Loading';
import NewConnection from './NewConnection';
import NewDiscussion from './NewDiscussion';
import NewGig from './NewGig';
import NewRating from './NewRating';
import NewResource from './NewResource';
import NewRole from './NewRole';
import Advert from '../common/Advert';
import ErrorMessage from '../common/ErrorMessage';
import * as imageUtils from '../../utils/imageUtils';

class ActivityFeedPage extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
       this.props.actions.getActivityFeed();
    }
    
    getActivity(item, index) {
        if(item.ActivityType === 'NewConnection') {
            return <NewConnection item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewDiscussion') {
            return <NewDiscussion item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewGig') {
            return <NewGig item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewResourceRating') {
            return <NewRating item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewResource') {
            return <NewResource item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
        else if(item.ActivityType === 'NewRole') {
            return <NewRole item={item} index={index} getThumbnail={this.getThumbnail} />;
        }
    }

    getThumbnail(imageUrl, roleType) {
        const params = '?width=120&aspectw=1&quality=80&mode=crop&format=jpg';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    }

    render() {
        return (
            <div className="main">
                <MetaTags>       
                    <title>Activity Feed - LoudUp</title>     
                    <meta id="description" name="description" content="Get updated on what is currently happening across the site from new users to new music, new discussion and more!" />   
                </MetaTags>
                <div className="container">
                    <div className="block-inner minimal-height">
                        <h1 className="section-alt">Activity Feed</h1>
                        <div className="row">
                            <div className="col-md-12">
                                <div id="activityFeedContainer">
                                {
                                    this.props.activityFeed && this.props.activityFeed.length ?
                                        <ul id="ulActivityFeedData" className="list-unstyled itemlist feed">
                                        {
                                            this.props.activityFeed.map((item, index) => {
                                                return <React.Fragment key={index}>
                                                    {this.getActivity(item, index)}
                                                    {
                                                        index === 4 ?
                                                            <li className="sponsored">
                                                                <p className="type">SPONSORED POST</p>
                                                                <div className="message">
                                                                    <p>
                                                                        <Advert adType="Footer" textOnly />
                                                                    </p>
                                                                </div>
                                                            </li>
                                                            : null
                                                    }
                                                </React.Fragment>;                                                    
                                            })
                                        }
                                        </ul>
                                        : this.props.loadingStatus && this.props.loadingStatus.status === 'LOADING' ? 
                                            <Loading />  
                                            : 
                                                this.props.loadingStatus && this.props.loadingStatus.status === 'FAILED' ?
                                                    <ErrorMessage error="Sorry, something went wrong! Unable to load recent activity" />
                                                    : 
                                                    <p>There is no recent activity to display</p>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ActivityFeedPage.propTypes = {
    actions: PropTypes.object.isRequired,
    activityFeed: PropTypes.array.isRequired,
    loadingStatus: PropTypes.string.isRequired
};

function mapStateToProps(state, ownProps) {
    return { activityFeed: state.activity.activityFeed, loadingStatus: state.activity.loadingStatus };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, activityActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityFeedPage);